import {
	ECP_PROJECTS_HINTS
} from '../CPProjectsTable/CPProjectsTablePropTypes.ts'

export type TProjectIconHint = Exclude<
	ECP_PROJECTS_HINTS,
	ECP_PROJECTS_HINTS.Express
>

export interface IProjectHintProps {
	text: string
	icon: string
	color: string
}

const HINT_PROPS: Record<TProjectIconHint, IProjectHintProps> = {
	[ECP_PROJECTS_HINTS.Blocked]: {
		text: 'Upload von Dokumenten blockiert',
		icon: 'not-allowed',
		color: 'color-cp-base-red'
	},
	[ECP_PROJECTS_HINTS.Messages]: {
		text: 'Neue Nachrichten',
		icon: 'mark-unread',
		color: 'color-cp-accent-200'
	},
	[ECP_PROJECTS_HINTS.Unpaid]: {
		text: 'Unbezahltes Projekt',
		icon: 'error',
		color: 'color-cp-base-red'
	},
	[ECP_PROJECTS_HINTS.HasUnsavedAnswers]: {
		text:
			'Die zur Verfügung gestellten Informationen sind noch nicht ' +
			'zur Kontrolle eingesendet worden',
		icon: 'alert',
		color: 'color-cp-accent-200'
	},
	[ECP_PROJECTS_HINTS.ActiveEmailReminders]: {
		text: 'E-Mail-Erinnerung',
		icon: 'email-reminder',
		color: 'color-cp-accent-200'
	}
}

export const getProjectHintProps = (
	hint: TProjectIconHint
): IProjectHintProps => HINT_PROPS[hint]
